import {
  Button,
  ClickAwayListener,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import { useState } from "react";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    sx={{ fontSize: 40 }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.warning.light,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.warning.light,
    fontSize: theme.typography.pxToRem(14),
  },
}));

type UserRolesTooltipProps = {
  roles: string[];
};

const UserRolesTooltip = ({ roles }: UserRolesTooltipProps) => {
  //var recipient = roles.s;
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("more...");

  const handleTooltipClose = () => {
    setOpen(false);
    setText("more...");
  };

  const handleTooltipOpen = () => {
    setOpen(!open);
    setText(open ? "more..." : "less...");
  };

  return (
    <>
      {roles.length > 1 ? (
        <div>
          {roles[0]}
          <div>{roles[1]}</div>
          <div>{roles[2]}</div>
        </div>
      ) : (
        <div>{roles}</div>
      )}
      <div></div>

      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <BootstrapTooltip
            open={open}
            PopperProps={{
              disablePortal: false,
            }}
            title={
              roles.length > 3 ? (
                <ul style={{ padding: "inherit", listStyleType: "none" }}>
                  {roles.map((role) => (
                    <li key={role}>{role}</li>
                  ))}
                </ul>
              ) : (
                <div>{roles}</div>
              )
            }
          >
            {roles.length > 3 ? (
              <Button
                sx={{
                  textTransform: "lowercase",
                  padding: "8px",
                  lineHeight: "0px",
                  color: "blue",
                }}
                disableElevation={true}
                disableRipple={true}
                size="large"
                onMouseOver={() => {
                  handleTooltipOpen();
                }}
                onMouseLeave={() => handleTooltipClose()}
              >
                {text}
              </Button>
            ) : (
              <div></div>
            )}
          </BootstrapTooltip>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default UserRolesTooltip;
